import { render, staticRenderFns } from "./DataTableDSMS.vue?vue&type=template&id=3bb7436b&scoped=true"
import script from "./DataTableDSMS.vue?vue&type=script&lang=js"
export * from "./DataTableDSMS.vue?vue&type=script&lang=js"
import style0 from "./DataTableDSMS.vue?vue&type=style&index=0&id=3bb7436b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7436b",
  null
  
)

export default component.exports